module.exports = __webpack_public_path__ + "img/alt-logo.c0b6e2f4.png";